import React from 'react';
import { BetHistoryContainer, BetHistoryFilterTypes, betStore, deepCopy } from '@pascal/pascal-core';

import { BetHistoryItem } from './betHistoryItem';

export const BetHistoryWrapper = () => {
  const betHistoryParser = (betHistory) => {
    const { betHistoryFilter } = betStore;

    switch (betHistoryFilter) {
      case BetHistoryFilterTypes.Win: {
        const winBets = betHistory.filter((bet) => bet.winAmount);
        winBets.forEach((bet) => {
          bet.additionalParams.markets = bet.additionalParams.markets.filter((bet) => bet.winAmount);
        });
        return winBets;
      }
      case BetHistoryFilterTypes.Lose: {
        const loseBets = deepCopy(betHistory);
        loseBets.forEach((bet) => {
          bet.additionalParams.markets = bet.additionalParams.markets.filter((bet) => !bet.winAmount);
        });
        return loseBets;
      }
      case BetHistoryFilterTypes.All:
        return betHistory;
    }
  };

  return (
    <BetHistoryContainer
      isGetViaSocket
      customStatus={null}
      customBetHistoryParser={betHistoryParser}
      renderBetHistoryItem={(bet) => <BetHistoryItem bet={bet} />}
      filterNames={[BetHistoryFilterTypes.All, BetHistoryFilterTypes.Win, BetHistoryFilterTypes.Lose]}
    />
  );
};
